import { gql } from '@apollo/client';

const GET_MANAGE_INSTALLERS = gql`
    query ManageInstallersList($limit: Int!, $page: Int!) {
        manageInstallersList(limit: $limit, page: $page) {
            data {
                id
                cognito_id
                first_name
                last_name
                username
                status
                createdAt
                license_number
                last_installation_date
                count
                avg_installation_time
                email
                last_logged_at
                phone_number
            }
            total_count
        }
    }
`;
const GET_MANAGE_WORK_ORDERS = gql`
    query Data($limit: Int!, $page: Int!) {
        getAdminInstallationsList(limit: $limit, page: $page) {
            data {
                id
                installer_user_id
                installer_name
                customer_id
                customer_name
                address_id
                machine_serial_id
                installation_date
                status
                installation_started_at
                installation_ended_at
                agency_id
                createdAt
                updatedAt
            }
            total_count
        }
    }
`;
const GET_CUSTOMERS_LIST = gql`
    query GetCustomersList {
        getCustomersList {
            data {
                id
                cognito_id
                first_name
                last_name
                username
                email
                phone_number
                application_type
                status
                last_logged_at
                profile_image
                role_id
                createdAt
                updatedAt
                user_addresses {
                    id
                    user_id
                    street
                    city
                    state
                    zip_code
                    country
                    address_type
                    createdAt
                    updatedAt
                }
                installer_users {
                    id
                    user_id
                    agency_id
                    license_number
                    avg_installation_time
                    createdAt
                    updatedAt
                }
            }
            current_page
            limit
            total_count
        }
    }
`;
const GET_INSTALLERS_LIST = gql`
    query GetInstallersList {
        getInstallersList {
            data {
                id
                cognito_id
                first_name
                last_name
                username
                email
                phone_number
                application_type
                status
                last_logged_at
                profile_image
                role_id
                createdAt
                updatedAt
                user_addresses {
                    id
                    user_id
                    street
                    city
                    state
                    zip_code
                    country
                    address_type
                    createdAt
                    updatedAt
                }
                installer_users {
                    id
                    user_id
                    agency_id
                    license_number
                    avg_installation_time
                    createdAt
                    updatedAt
                }
            }
            current_page
            limit
            total_count
        }
    }
`;

const GET_INSTALLER_DETAILS = gql`
    query GetInstallerDetails($getInstallerDetailsId: Int) {
        getInstallerDetails(id: $getInstallerDetailsId) {
            id
            cognito_id
            first_name
            last_name
            username
            email
            phone_number
            application_type
            status
            last_logged_at
            profile_image
            role_id
            createdAt
            updatedAt
            user_addresses {
                id
                user_id
                street
                city
                state
                zip_code
                country
                address_type
                createdAt
                updatedAt
            }
            installer_users {
                id
                user_id
                agency_id
                license_number
                avg_installation_time
                createdAt
                updatedAt
            }
        }
    }
`;
const GET_MANAGE_CUSTOMERS_LIST = gql`
    query GetManageCustomerList($limit: Int, $page: Int, $status: Int) {
        getManageCustomerList(limit: $limit, page: $page, status: $status) {
            data {
                id
                first_name
                last_name
                username
                email
                status
                machine_serial_ids
                machine_ids
                user_addresses {
                    id
                    user_id
                    street
                    city
                    state
                    zip_code
                    country
                    address_type
                    createdAt
                    updatedAt
                }
            }
            limit
            current_page
            total_count
        }
    }
`;
const GET_CUSTOMER_DETAILS = gql`
    query GetCustomerDetails($getCustomerDetailsId: Int!) {
        getCustomerDetails(id: $getCustomerDetailsId) {
            id
            cognito_id
            first_name
            last_name
            username
            email
            phone_number
            application_type
            status
            last_logged_at
            profile_image
            role_id
            createdAt
            updatedAt
            user_addresses {
                id
                user_id
                street
                city
                state
                zip_code
                country
                address_type
                createdAt
                updatedAt
            }
            device_arn
            installer_users {
                id
                user_id
                agency_id
                license_number
                avg_installation_time
                createdAt
                updatedAt
            }
        }
    }
`;
const GET_INSTALLATION_STATUS_LIST = gql`
    query GetInstallationStatusList {
        getInstallationStatusList {
            id
            status
            description
        }
    }
`;
const GET_MANAGE_ADMIN_ROLES_LIST = gql`
    query GetAdminRolesList {
        getAdminRolesList {
            id
            name
        }
    }
`;
const GET_MANAGE_ADMIN_LIST = gql`
    query GetAdminsList($limit: Int!, $page: Int!) {
        getAdminsList(limit: $limit, page: $page) {
            data {
                id
                username
                email
                last_logged_at
                cognito_id
                first_name
                last_name
                status
                phone_number
                role_id
                user_addresses {
                    country
                    id
                }
            }
            total_count
        }
    }
`;
const GET_CUSTOMER_HEATER_METRICS = gql`
    query GetCustomerDeviceMetrics($userId: Int!) {
        getCustomerDeviceMetrics(user_id: $userId) {
            water_temperature
            gpu_utilization
            internet
            power
            sensor_timestamp
            device_id
            avg_gpu_util_7d
            avg_gpu_util_30d
            power_usage
            operation_mode
            installed_date
            installed_by
        }
    }
`;
const GET_DEVICE_STATUS_HISTORY = gql`
    query GetCustomerDeviceStatusHistory($deviceId: String!) {
        getCustomerDeviceStatusHistory(device_id: $deviceId) {
            createdAt
            status
            sensor_timestamp
        }
    }
`;
const GET_TEMPARATURE_HISTORY = gql`
    query GetTemperatureHistory($deviceId: String!) {
        getTemperatureHistory(device_id: $deviceId) {
            device_id
            history {
                date
                temp_avg
            }
        }
    }
`;
const GET_CURRENT_EARNINGS = gql`
    query GetCustomerCurrentEarnings($userId: Int!) {
        getCustomerCurrentEarnings(user_id: $userId) {
            this_month_earnings
            total_earnings
            vast_start_date
            renting_status
        }
    }
`;
const GET_HISTORICAL_EARNINGS = gql`
    query GetDeviceHistoricalEarnings($deviceId: String!) {
        getDeviceHistoricalEarnings(device_id: $deviceId) {
            last_6_months_earnings {
                earnings
                gpu_utilization
                month
                year
            }
        }
    }
`;

const GET_USER_PERMISSIONS = gql`
    query GetPermissions {
        getPermissions {
            actions
            feature_id
            feature_name
            feature_slug
            user_id
        }
    }
`;
export {
    GET_MANAGE_INSTALLERS,
    GET_MANAGE_WORK_ORDERS,
    GET_CUSTOMERS_LIST,
    GET_INSTALLERS_LIST,
    GET_INSTALLER_DETAILS,
    GET_MANAGE_CUSTOMERS_LIST,
    GET_CUSTOMER_DETAILS,
    GET_INSTALLATION_STATUS_LIST,
    GET_MANAGE_ADMIN_LIST,
    GET_MANAGE_ADMIN_ROLES_LIST,
    GET_CUSTOMER_HEATER_METRICS,
    GET_DEVICE_STATUS_HISTORY,
    GET_TEMPARATURE_HISTORY,
    GET_CURRENT_EARNINGS,
    GET_HISTORICAL_EARNINGS,
    GET_USER_PERMISSIONS,
};
